import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingCircle() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
      <CircularProgress />
    </Box>
  );
}
